<template>
  <div class="home">
    <nav class="nav">
      <img class="nav__logo" src="../assets/fast.jpg" alt="Fast logo">
    </nav>
    <main class="content">
      <div class="content__header">
        Wybierz katalog
      </div>
      <div class="content__books books">
        <router-link class="books__item" :to="'/view/' + key" v-for="(book, key) in manifest.books" :key="key">
          <img :src="'/books/' + key + '/' + book.pages.prefix + getNumber(book) + book.pages.suffix + book.pages.extension" :alt="book.title">
        </router-link>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      manifest: {
        books: {}
      }
    }
  },
  methods: {
    getManifest() {
      this.axios.get('/books/manifest.json')
          .then(response => {
            this.manifest.books = Object.assign({}, response.data.books);
          })
          .catch(error => {
            console.log(error);
          })
    },
    getNumber(book) {
      if(!book.append_zero){
        return 1;
      }
      let digits = book.pages.count.toString().length;
      let number = 1;
      if(digits > 1){
        for(let j = 0; j < (digits - 1); j++){
          number = '0' + number;
        }
      }
      return number;
    }
  },
  mounted() {
    this.getManifest();
  }
}
</script>

<style lang="scss">
  .nav {
    box-sizing: border-box;
    padding: 0 10px;
    width: 100%;
    height: 90px;
    display: flex;
    align-items: center;
    &__logo {
      width: 60px;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    &__header {
      font-size: 36px;
      margin-bottom: 20px;
      text-transform: uppercase;
      font-weight: bold;
      color: #333333;
    }
    &__books {
      width: 100%;
    }
  }

  .books {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    &__item {
      width: 30%;
      max-width: 400px;
      box-shadow: rgba(0, 0, 0, .6) 0 0 20px;
      transition: all .2s;
      &:hover {
        transform: scale(1.01);
      }
      & > img {
        vertical-align: middle;
        width: 100%;
      }
    }
  }
</style>
